
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 54 48","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.972 26.325C51.29 13.547 40.997 5.869 30 4.678V3c0-1.66-1.34-3-3-3s-3 1.34-3 3v1.678C12.966 5.868 2.766 13.547.028 26.325c-.206.947.797 1.997 1.753 1.069 4.875-5.156 10.097-4.913 14.87 3.469.496.89 1.396.806 1.846 0C20.39 27.543 22.707 24 27 24c5.484 0 8.269 6.45 8.503 6.863.45.806 1.35.89 1.847 0 4.781-8.391 10.04-8.57 14.869-3.47.965.938 1.96-.121 1.753-1.068zM24 28.285V40.5c0 .825-.675 1.5-1.5 1.5a1.502 1.502 0 01-1.416-1.003 2.991 2.991 0 00-3.825-1.828 2.995 2.995 0 00-1.828 3.825 7.502 7.502 0 007.07 4.997c4.133 0 7.5-3.366 7.5-7.5V28.275c-.854-.74-1.857-1.275-3-1.275-1.154.01-2.1.45-3 1.284z","fill":"currentColor"}})])
          )
        }
      }
    